// extracted by mini-css-extract-plugin
module.exports = {"root":"VehicleFontIcon_root__1pwFc","vehicle":"VehicleFontIcon_vehicle__3hF4-","company":"VehicleFontIcon_company__3uBAI"};